import { render, staticRenderFns } from "./BookingView.vue?vue&type=template&id=5ff35078"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports